import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Alert from "@material-ui/lab/Alert";
import TableCell from "@material-ui/core/TableCell";
import Select from "react-select";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Radio, RadioGroup, FormControlLabel } from "@material-ui/core";
import { fetchWithToken } from "../../../../apiUtils";
import "./MTEstyles.css";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  card: {
    marginTop: 40,
  },
  button: {
    margin: "5px",
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
  bulkLoading: {
    marginTop: "15%",
    marginLeft: "50%",
  },
  checkbox: {
    width: "20px",
    height: "20px",
  },
  centerButton: {
    color: "white",
    backgroundColor: "#dc3545",
  },
  datailCard: {
    width: "60%",
    marginLeft: "20%",
    marginTop: "25px",
  },
});

const AssignTeamsEndpoint = (props) => {
  const { poolsData } = props;
  const classes = useStyles();
  const [userData, setUserData] = useState(null);
  const [updateType, setUpdateType] = useState("single");

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });
  };

  const clearAlert = () => {
    setAlertMessage({
      message: "",
      varient: "",
      active: false,
    });
  };

  const changeHandler = (value, name) => {
    clearAlert();
    if (value == "single" || value == "bulk") {
      setUserData(null);
      setUpdateType(value);
      return;
    }
  };

  return (
    <>
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <Card className={classes.card}>
            {alertMessage.active && (
              <Alert
                severity={alertMessage.varient}
                onClose={() => clearAlert()}
              >
                {alertMessage.message}
              </Alert>
            )}
            <Typography
              sx={{ fontSize: 14 }}
              style={{ margin: "20px", fontSize: "1.5em" }}
              color="text.secondary"
              gutterBottom
            >
              Assign Teams
            </Typography>

            <div class="mb-3 row">
              <div class="col-sm-1 col-form-label" />
              <div class="col-sm-7">
                <RadioGroup
                  row
                  name="row-radio-buttons-group"
                  onChange={(e) => changeHandler(e.target.value, e.target.name)}
                  defaultValue="single"
                >
                  <FormControlLabel
                    default
                    value="single"
                    control={<Radio color="primary" />}
                    label="Single"
                  />
                  <FormControlLabel
                    value="bulk"
                    control={<Radio color="primary" />}
                    label="Bulk"
                  />
                </RadioGroup>
              </div>
            </div>
            {updateType == "single" ? (
              <SingleAssign
                sendAlert={sendAlert}
                clearAlert={clearAlert}
                setUserData={setUserData}
                poolsData={poolsData}
              />
            ) : (
              <BulkAssign
                sendAlert={sendAlert}
                clearAlert={clearAlert}
                poolsData={poolsData}
              />
            )}
          </Card>
        </div>
      </div>
      {userData != null && (
        <EndpointUserData
          sendAlert={sendAlert}
          clearAlert={clearAlert}
          userData={userData}
          setUserData={setUserData}
        />
      )}
    </>
  );
};

const SingleAssign = (props) => {
  const classes = useStyles();
  const { sendAlert, clearAlert, setUserData, poolsData } = props;

  const [inputGMIN, setInputGMIN] = useState("");
  const [inputPhoneNumber, setInputPhoneNumber] = useState(null);
  const [inputPool, setInputPool] = useState(null);
  const [inputQueue, setInputQueue] = useState(false);
  const [inputEmail, setInputEmail] = useState(true);

  const [assignSpecific, setAssignSpecific] = useState(false);
  const [loading, setLoading] = useState(false);

  const getPools = () => {
    return poolsData.map((pool) => {
      return { value: pool.id, label: `${pool.name}` };
    });
  };

  const setAssignSpecificHandler = () => {
    setAssignSpecific((prev) => {
      if (prev) setInputPool(null);
      return !prev;
    });
  };

  const singleSubmitHandler = (e) => {
    e.preventDefault();
    clearAlert();

    let formData = {
      gmin: inputGMIN ? Number(inputGMIN) : null,
      phoneNumber: inputPhoneNumber ? Number(inputPhoneNumber) : null,
      poolId: inputPool ? Number(inputPool) : null,
      emailNotify: !!inputEmail,
      addToQueue: !!inputQueue,
    };

    setUserData(null);

    var stringArray = [];
    var errorMesssage = "Validation Error - ";
    if (formData.gmin == "") stringArray.push("GMIN");
    if (assignSpecific && formData.poolId == "") stringArray.push("Pool");

    if (formData.gmin == "" || (assignSpecific && formData.poolId == "")) {
      stringArray.map((error, index) => {
        if (index === stringArray.length - 1)
          errorMesssage += index == 0 ? error : " & " + error;
        else errorMesssage += index == 0 ? error : ", " + error;
      });
      sendAlert((errorMesssage += " Required"), "warning");
      return;
    }

    setLoading(true);

    var alertType = "success";
    var alreadyExists = false;
    var successfulResponse = false;

    fetchWithToken(`api/TeamsEndpoint/ByGmin/${formData.gmin}/`)
      .then((res) => {
        if (res.ok) {
          alreadyExists = true;
          return res.json();
        } else {
          fetchWithToken(`api/TeamsEndpoint/assign`, "POST", formData)
            .then((response) => {
              if (response.ok) successfulResponse = true;
              else alertType = "warning";
              return response.json();
            })
            .then((data) => {
              setLoading(false);
              if (successfulResponse) {
                setUserData(data.teamsEndpoint);
                sendAlert(data.returnMessage, alertType);
                clearAll();
              } else sendAlert(data.returnMessage, alertType);
            });
        }
      })
      .then((data) => {
        if (alreadyExists) {
          sendAlert(data.returnMessage, "warning");
          setUserData(data.returnObject);
          setLoading(false);
        }
      });
  };

  const clearAll = () => {
    setInputGMIN(null);
    setInputPhoneNumber(null);
    setInputPool(null);
    setAssignSpecific(false);
    setInputQueue(false);
    setInputEmail(true);
  };

  return (
    <>
      <div style={{ margin: "25px" }}>
        <form onSubmit={(e) => singleSubmitHandler(e)}>
          <div class="mb-3 row">
            <div class="col-sm-12">
              <input
                name="GMIN"
                type="number"
                maxlength="40"
                value={inputGMIN}
                class="form-control"
                style={{ fontSize: "0.875rem" }}
                placeholder="GMIN"
                onChange={(e) => {
                  clearAlert();
                  setInputGMIN(e.target.value);
                }}
              />
            </div>
          </div>
          <div class="mb-3 row">
            <div class="col-sm-12">
              <input
                name="phoneNumber"
                type="number"
                maxlength="15"
                class="form-control"
                value={inputPhoneNumber}
                style={{ fontSize: "0.875rem" }}
                placeholder="Enter Phone Number"
                onChange={(e) => {
                  clearAlert();
                  const value = e.target.value.trim();
                  setInputPhoneNumber(value === "" ? null : value);
                  if (e.target.value.length > 0) {
                    setAssignSpecific(false);
                    setInputPool(null);
                  }
                }}
              />
            </div>
          </div>
          <div class="mb-3 row">
            <div class="col-sm-5">
              <h6>Assign to specific pool:</h6>
            </div>
            <div class="col-sm-5">
              <div>
                <input
                  id="poolCheck"
                  name="specificPool"
                  type="checkbox"
                  checked={assignSpecific}
                  class="form-check-input"
                  className={classes.checkbox}
                  onClick={() => {
                    clearAlert();
                    setAssignSpecificHandler();
                  }}
                />
              </div>
            </div>
          </div>
          {assignSpecific && (
            <div style={{ marginBottom: "15px", width: "100%" }}>
              <Select
                placeholder="Select Pool"
                options={getPools()}
                onChange={(e) => {
                  clearAlert();
                  setInputPool(e.value);
                  setInputPhoneNumber(null);
                }}
                menuPortalTarget={document.querySelector("body")}
              />
            </div>
          )}
          <div class="mb-3 row">
            <div class="col-sm-5">
              <h6>Add To Queue:</h6>
            </div>
            <div class="col-sm-5">
              <div>
                <input
                  class="form-check-input"
                  className={classes.checkbox}
                  type="checkbox"
                  name="addToQueue"
                  checked={inputQueue}
                  onChange={(e) => {
                    clearAlert();
                    setInputQueue((prev) => !prev);
                  }}
                />
              </div>
            </div>
          </div>
          <div class="mb-3 row">
            <div class="col-sm-5">
              <h6>Notify By Email:</h6>
            </div>
            <div class="col-sm-5">
              <div>
                <input
                  class="form-check-input"
                  className={classes.checkbox}
                  type="checkbox"
                  name="emailNotify"
                  checked={inputEmail}
                  onChange={(e) => {
                    clearAlert();
                    setInputEmail((prev) => !prev);
                  }}
                />
              </div>
            </div>
          </div>
          {loading && (
            <>
              <div style={{ margin: "25px" }}>
                <span style={{ display: "table", margin: "0 auto" }}>
                  Please Wait For Assign to Finish
                </span>
                <LinearProgress />
              </div>
            </>
          )}

          <Button
            type="submit"
            variant="contained"
            className={classes.button}
            color="primary"
          >
            Assign
          </Button>
        </form>
      </div>
    </>
  );
};

const BulkAssign = (props) => {
  const classes = useStyles();
  const { sendAlert, clearAlert, poolsData } = props;

  const [isEmpty, setIsEmpty] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const [inputPool, setInputPool] = useState(null);
  const [inputQueue, setInputQueue] = useState(false);
  const [inputEmail, setInputEmail] = useState(true);
  const [providedGMINs, setProvidedGMINs] = useState({ userGMINs: [] });

  const [successFetch, setSuccessFetch] = useState(false);
  const [assignSpecific, setAssignSpecific] = useState(false);
  const [loading, setLoading] = useState(false);

  const fileChangeHandler = (event) => {
    handleCancel();
    clearAlert();

    const file = event.target.files[0];
    event.target.value = "";
    setSelectedFile(file);
    setIsSelected(true);

    const reader = new FileReader();
    reader.onload = function (event) {
      const lines = event.target.result.split(/\r?\n/).filter(Boolean);
      const validNumbersSet = new Set();

      for (let line of lines) {
        const trimmed = line.trim();
        if (/^\d{9}$/.test(trimmed)) {
          validNumbersSet.add(Number(trimmed));
        }
      }

      const validNumbers = Array.from(validNumbersSet); // ensures uniqueness

      if (validNumbers.length === 0) {
        setIsEmpty(true);
        console.log("No valid 9-digit numbers found", "warning");
      } else {
        setIsEmpty(false);
        setProvidedGMINs({ userGMINs: validNumbers }); // validNumbers is number[]
      }
    };

    reader.readAsText(file);
  };

  const handleSubmission = (event) => {
    event.preventDefault();
    clearAlert();

    let formData = {
      userGMINs: providedGMINs.userGMINs,
      poolId: inputPool,
      addToQueue: inputQueue,
      emailNotify: inputEmail,
    };

    if (isEmpty) {
      sendAlert("No Content", "warning");
      return;
    }
    if (assignSpecific && formData.poolId == null) {
      sendAlert("No Pool Selected", "warning");
      return;
    }
    if (!isSelected) {
      sendAlert("No File Selected", "warning");
      return;
    }

    var successfulResponse = false;
    setLoading(true);

    console.log("formData", formData);

    fetchWithToken(`api/TeamsEndpoint/bulkAssign`, "POST", formData)
      .then((res) => {
        if (res.ok) {
          successfulResponse = true;
          setSuccessFetch(true);
        }
        return res.json();
      })
      .then((data) => {
        setSuccessFetch(false);
        sendAlert(data.returnMessage, successfulResponse ? "success" : "error");
        setLoading(false);
      });

    handleCancel();
  };

  useEffect(() => {
    if (successFetch) clearAll();
  }, [successFetch]);

  const clearAll = () => {
    handleCancel();
    setInputPool(null);
    setAssignSpecific(false);
    setInputQueue(false);
    setInputEmail(true);
  };

  const handleCancel = (event) => {
    clearAlert();
    setSelectedFile(null);
    setIsEmpty(false);
    setIsSelected(false);
    setProvidedGMINs({ userGMINs: [] });
  };

  const getPools = () => {
    return poolsData.map((pool) => {
      return { value: pool.id, label: `${pool.name}` };
    });
  };

  return (
    <>
      <div style={{ margin: "25px" }}>
        <form onSubmit={handleSubmission}>
          <div class="mb-3 row">
            <div class="col-sm-8">
              <h6>Assign to specific pool:</h6>
            </div>
            <div class="col-sm-4">
              <div class="form-check">
                <input
                  type="checkbox"
                  name="specificPool"
                  checked={assignSpecific}
                  class="form-check-input"
                  className={classes.checkbox}
                  onClick={() => {
                    clearAlert();
                    setAssignSpecific((prev) => !prev);
                  }}
                />
              </div>
            </div>
          </div>
          {assignSpecific && (
            <div style={{ margin: "15px", width: "50%" }}>
              <Select
                placeholder="Select Pool"
                options={getPools()}
                onChange={(e) => {
                  clearAlert();
                  setInputPool(e.value);
                }}
                menuPortalTarget={document.querySelector("body")}
              />
            </div>
          )}
          <div class="mb-3 row">
            <div class="col-sm-8">
              <h6>Add to queue if numbers are not available for assignment:</h6>
            </div>
            <div class="col-sm-4">
              <div class="form-check">
                <input
                  type="checkbox"
                  name="addToQueue"
                  checked={inputQueue}
                  class="form-check-input"
                  className={classes.checkbox}
                  onClick={() => {
                    clearAlert();
                    setInputQueue((prev) => !prev);
                  }}
                />
              </div>
            </div>
          </div>
          <div class="mb-3 row">
            <div class="col-sm-8">
              <h6>Notify By Email:</h6>
            </div>
            <div class="col-sm-4">
              <div class="form-check">
                <input
                  type="checkbox"
                  name="emailNotify"
                  checked={inputEmail}
                  class="form-check-input"
                  className={classes.checkbox}
                  onClick={() => {
                    clearAlert();
                    setInputEmail((prev) => !prev);
                  }}
                />
              </div>
            </div>
          </div>
          {loading && (
            <>
              <div style={{ margin: "25px" }}>
                <span style={{ display: "table", margin: "0 auto" }}>
                  Please Wait For Bulk Assign to Finish
                </span>
                <LinearProgress />
              </div>
            </>
          )}
          <div class="mb-3 row">
            <TableCell class="col-sm-8">
              Upload File:{" "}
              {isSelected && (
                <>
                  {selectedFile.name} ({providedGMINs.userGMINs.length} GMINs)
                </>
              )}
              <br />
              <Button
                variant="contained"
                component="label"
                className={classes.button}
                color="primary"
              >
                Select File
                <input
                  type="file"
                  name="file"
                  accept=".txt"
                  onChange={fileChangeHandler}
                  hidden
                />
              </Button>
              <Button
                type="submit"
                variant="contained"
                className={classes.button}
                color="primary"
              >
                Submit
              </Button>
              <Button
                variant="contained"
                onClick={handleCancel}
                className={classes.button}
              >
                Cancel
              </Button>
            </TableCell>
          </div>
        </form>
      </div>
    </>
  );
};

const EndpointUserData = (props) => {
  const classes = useStyles();
  const { sendAlert, clearAlert, userData, setUserData } = props;
  const [loading, setLoading] = useState(false);

  const releaseEndpoint = (e) => {
    e.preventDefault();
    clearAlert();
    setLoading(true);

    let identifier = userData.gmin?.toString() ?? `byGMID/${userData.gmid}`;

    // Extract only the GMID for alerts
    const gmidForAlert = identifier.startsWith("byGMID/")
      ? identifier.replace("byGMID/", "")
      : identifier;

    fetchWithToken(`api/TeamsEndpoint/release/${identifier}`, "DELETE").then(
      (res) => {
        if (res.ok) {
          sendAlert(
            `Endpoint linked to ${gmidForAlert} - Successfully Released`,
            "success"
          );
          setUserData(null);
        } else if (res.status === 409) {
          sendAlert(`Conflict - Unable to Release Endpoint`, "danger");
        } else {
          sendAlert(
            `Unknown Error - Error Releasing Endpoint linked to ${gmidForAlert}`,
            "warning"
          );
        }
        setLoading(false);
      }
    );
  };

  const getDateFormat = (date) => {
    if (date == null) return;
    var newDate = date.split("T")[0];
    var dateArray = newDate.split("-");
    var year = dateArray[0];
    var month = dateArray[1];
    var day = dateArray[2];
    var fullTime = date.split("T")[1].split(".")[0];
    var hour = fullTime.substring(0, 2);
    var finalTime;
    if (parseInt(hour) > 12) {
      if (parseInt(hour) > 21) {
        finalTime = hour - 12 + fullTime.substring(2, 5);
      } else {
        finalTime = "0" + (hour - 12) + fullTime.substring(2, 5);
      }
      finalTime += " PM";
    } else {
      finalTime = hour + fullTime.substring(2, 5);
      finalTime += " AM";
    }
    var myDate = `${year}-${month}-${day}`;
    return myDate;
  };

  return (
    <>
      {userData != null && (
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <Card className={classes.datailCard}>
              <CardContent>
                <Typography
                  sx={{ fontSize: 14 }}
                  style={{ margin: "20px", fontSize: "1.5em" }}
                  color="text.secondary"
                  gutterBottom
                >
                  Existing Endpoint
                </Typography>
                <form style={{ margin: "20px" }} onSubmit={releaseEndpoint}>
                  <div class="mb-3 row">
                    <div class="col-sm-1" />
                    <div class="col-sm-3">
                      <h6>Number:</h6>
                    </div>
                    <div class="col-sm-7">
                      <h6>{userData.phoneNumber}</h6>
                    </div>
                    <div class="col-sm-1" />
                  </div>

                  <div class="mb-3 row">
                    <div class="col-sm-1" />
                    <div class="col-sm-3">
                      <h6>GMID:</h6>
                    </div>
                    <div class="col-sm-7">
                      <h6>{userData.gmid}</h6>
                    </div>
                    <div class="col-sm-1" />
                  </div>

                  <div class="mb-3 row">
                    <div class="col-sm-1" />
                    <div class="col-sm-3">
                      <h6>GMIN:</h6>
                    </div>
                    <div class="col-sm-7">
                      <h6>{userData.gmin}</h6>
                    </div>
                    <div class="col-sm-1" />
                  </div>

                  <div class="mb-3 row">
                    <div class="col-sm-1" />

                    <div class="col-sm-3">
                      <h6>Display Name:</h6>
                    </div>
                    <div class="col-sm-7">
                      <h6>{userData.displayName}</h6>
                    </div>
                    <div class="col-sm-1" />
                  </div>

                  <div class="mb-3 row">
                    <div class="col-sm-1" />

                    <div class="col-sm-3">
                      <h6>Pool Name:</h6>
                    </div>
                    <div class="col-sm-7">
                      <h6>{userData.pool.name}</h6>
                    </div>
                    <div class="col-sm-1" />
                  </div>

                  <div class="mb-3 row">
                    <div class="col-sm-1" />

                    <div class="col-sm-3">
                      <h6>Dial Plan:</h6>
                    </div>
                    <div class="col-sm-7">
                      <h6>{userData.dialPlan}</h6>
                    </div>
                    <div class="col-sm-1" />
                  </div>

                  <div class="mb-3 row">
                    <div class="col-sm-1" />

                    <div class="col-sm-3">
                      <h6>Voice Policy:</h6>
                    </div>
                    <div class="col-sm-7">
                      <h6>{userData.voicePolicy}</h6>
                    </div>
                    <div class="col-sm-1" />
                  </div>

                  <div class="mb-3 row">
                    <div class="col-sm-1" />

                    <div class="col-sm-3">
                      <h6>Assignment Date:</h6>
                    </div>
                    <div class="col-sm-7">
                      <h6>{getDateFormat(userData.assignmentDate)}</h6>
                    </div>
                    <div class="col-sm-1" />
                  </div>

                  <div class="mb-3 row">
                    <div class="col-sm-1" />

                    <div class="col-sm-3">
                      <h6>SIP Address</h6>
                    </div>
                    <div class="col-sm-7">
                      <h6>{userData.sipAddress}</h6>
                    </div>
                    <div class="col-sm-1" />
                  </div>

                  {loading && (
                    <>
                      <div style={{ margin: "25px" }}>
                        <span style={{ display: "table", margin: "0 auto" }}>
                          Please Wait For Release to Finish
                        </span>
                        <LinearProgress />
                      </div>
                    </>
                  )}

                  <Button
                    style={{ margin: "10px" }}
                    type="submit"
                    variant="contained"
                    className={classes.centerButton}
                  >
                    Release
                  </Button>
                </form>
              </CardContent>
            </Card>
          </div>
        </div>
      )}
    </>
  );
};

export default AssignTeamsEndpoint;
